module.exports = __webpack_public_path__ + "img/logo_roomInspection.4cfbf2fd.png";